import { FlexibleColumn } from '@ip-only/front-end-library';

const addressColumn: FlexibleColumn = {
  id: 'addressColumn',
  header: 'hpReportModal.pill.address',
  alignment: 'left',
};

const statusColumn: FlexibleColumn = {
  id: 'statusColumn',
  header: 'hpReportModal.pill.status',
  alignment: 'left',
};

export const hPColumns: FlexibleColumn[] = [addressColumn, statusColumn];
